class CustomAnnouncementSlider extends HTMLElement {
  constructor() {
    super();
    this.currentSlide = 0;
    this.autoplayInterval = null;
    this.slides = [];
    this.track = null;
    this.closeButton = null;
    this.totalSlides = 0;
  }

  connectedCallback() {
    this.#init();
  }

  disconnectedCallback() {
    this.#stopAutoplay();
  }

  #init() {
    const alwaysShow = this.dataset.alwaysShow === 'true';

    if (!this.#isClosed() || alwaysShow) {
      this.#show();
      
      this.slides = Array.from(this.querySelectorAll('.custom-announcement-slider__slide'));
      this.track = this.querySelector('.custom-announcement-slider__track');
      this.closeButton = this.querySelector('.custom-announcement-slider__close');
      this.totalSlides = this.slides.length;

      if (this.track && this.totalSlides > 1) {
        const firstClone = this.slides[0].cloneNode(true);
        firstClone.classList.add('custom-announcement-slider__slide--clone');
        this.track.appendChild(firstClone);

        this.slides = Array.from(this.querySelectorAll('.custom-announcement-slider__slide'));

        this.track.addEventListener('transitionend', () => this.#handleTransitionEnd());
      }
      
      this.#setupControls();
      
      if (this.slides.length > 1) {
        this.#startAutoplay();
      }
    }
  }

  #setupControls() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.#close());
    }

    this.addEventListener('mouseenter', () => this.#pauseAutoplay());
    this.addEventListener('mouseleave', () => this.#resumeAutoplay());
  }

  #close() {
    this.#stopAutoplay();
    this.#setClosed();
    this.#hide();
  }

  #hide() {
    const bar = this.closest('.custom-announcement-bar');
    if (bar) {
      bar.style.display = 'none';
    }
  }

  #show() {
    const bar = this.closest('.custom-announcement-bar');
    if (bar) {
      bar.style.display = 'block';
    }
  }

  #isClosed() {
    const closedDate = localStorage.getItem('announcement-bar-closed-date');
    if (!closedDate) return false;

    const today = new Date().toDateString();
    return closedDate === today;
  }

  #setClosed() {
    const today = new Date().toDateString();
    localStorage.setItem('announcement-bar-closed-date', today);
  }

  #goToSlide(index, immediate = false) {
    if (!this.track || index < 0 || index >= this.slides.length) return;

    this.currentSlide = index;
    const translateX = -this.currentSlide * 100;

    if (immediate) {
      const previousTransition = this.track.style.transition;
      this.track.style.transition = 'none';
      this.track.style.transform = `translateX(${translateX}%)`;
      this.track.offsetHeight;

      this.track.style.transition = previousTransition;
    } else {
      this.track.style.transform = `translateX(${translateX}%)`;
    }
  }

  #goToNextSlide() {
    if (this.slides.length <= 1) return;

    let nextIndex = this.currentSlide + 1;

    if (nextIndex >= this.slides.length) {
      nextIndex = this.slides.length - 1;
    }

    this.#goToSlide(nextIndex);
  }

  #handleTransitionEnd() {
    if (this.currentSlide === this.slides.length - 1 && this.totalSlides > 1) {
      this.currentSlide = 0;
      this.#goToSlide(this.currentSlide, true);
    }
  }

  #startAutoplay() {
    const interval = parseInt(this.dataset.interval || 3000);

    if (this.slides.length <= 1) return;

    this.autoplayInterval = setInterval(() => {
      this.#goToNextSlide();
    }, interval);
  }

  #stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  #pauseAutoplay() {
    this.#stopAutoplay();
  }

  #resumeAutoplay() {
    this.#startAutoplay();
  }

}

customElements.define('custom-announcement-slider', CustomAnnouncementSlider);

